module.exports = __webpack_public_path__ + "ddd22f65df2e0ccd1a122044a894b5a6.eot";


//////////////////
// WEBPACK FOOTER
// ./~/react-html5video/src/assets/font/video-fontello.eot?1445970113105
// module id = 639
// module chunks = 0